import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ButtonRadio } from '@/components'
import { Deployment } from '@/models/deployment.ts'
import { DeploymentBill } from '@/models/deploymentBill.ts'
import DeploymentBilling from '@/pages/auto-deploy/components/DeploymentBilling.tsx'
import DeploymentCredential from '@/pages/auto-deploy/components/DeploymentCredential.tsx'
import DeploymentHistory from '@/pages/auto-deploy/components/DeploymentHistory.tsx'
// import DeploymentMonitor from '@/pages/auto-deploy/components/DeploymentMonitor.tsx'
import DeploymentTarget from '@/pages/auto-deploy/components/DeploymentTarget.tsx'
interface DeploymentDetailProp {
  _deployment: Deployment
  _deploymentBills: Map<string, DeploymentBill[]>
  _enabled?: boolean
  onUpdate?: () => void
}

type Item = {
  label: string
  value: string
  Comp: JSX.Element
}

export default function DeploymentDetail({
  _deployment,
  _deploymentBills,
  _enabled,
  onUpdate,
}: DeploymentDetailProp) {
  const { t } = useTranslation('autoDeploy')

  const targetItem = {
    label: t('deployTargetLabel'),
    value: 'DeployTarget',
    Comp: <DeploymentTarget _deployment={_deployment} _enabled={_enabled} onUpdate={onUpdate} />,
  }

  const credentialItem = {
    label: t('deployCredentialLabel'),
    value: 'Credentials',
    Comp: <DeploymentCredential _deployment={_deployment} />,
  }

  const billingItem = {
    label: t('deployBillingLabel'),
    value: 'Billing',
    Comp: <DeploymentBilling _deployment={_deployment} _deploymentBills={_deploymentBills} />,
  }
  const historyItem = {
    label: t('deployHistoryLabel'),
    value: 'DeployHistory',
    Comp: <DeploymentHistory _deployment={_deployment} _deploymentBills={_deploymentBills} />,
  }

  // const monitorItem = {
  //   label: 'Monitor',
  //   value: 'Monitor',
  //   Comp: <DeploymentMonitor />,
  // }

  const items: Item[] = [targetItem, credentialItem, billingItem, historyItem].filter(
    Boolean,
  ) as Item[]
  const [tab, setTab] = useState(items[0].value)

  return (
    <div className="px-4">
      <ButtonRadio
        className="mb-2 "
        value={tab}
        items={items}
        onChange={(e) => setTab(e)}
        size="small"
      />

      <div className="bg-neutral-50 p-4 rounded-lg">
        {items.map((item) => (
          <div key={item.value} className={tab === item.value ? 'block' : 'hidden'}>
            {item.Comp}
          </div>
        ))}
      </div>
    </div>
  )
}
